import { DefaultTheme } from "styled-components";

export type Theme = CleverbaseTheme;

export function setTheme(_theme: Theme): DefaultTheme {
  return cleverbaseTheme;
}

export interface CleverbaseTheme {
  type: "cleverbase";
}

export const cleverbaseTheme: DefaultTheme = {
  fontFamily: '"Inter", sans-serif',
  headingFontFamily: '"Headland One", serif',
  backgroundColor: "#ffffff",
  header: {
    backgroundColor: "#FAF5EB",
    textColor: "#23231F",
  },
  viewBox: {
    backgroundColor: "#FAF5EB",
    outlineColor: "#FAF5EB",
    outlineWidth: "0px",
  },
  primaryButton: {
    backgroundColor: "#005f9c",
    textColor: "#e2eef7",
    backgroundColorHover: "#e2eef7",
    textColorHover: "#005f9c",
  },
  link: {
    textColor: "#23231F",
  },
  clientInfo: {
    backgroundColor: "#ffffff",
    textColor: "#101418",
  },
  secondaryButton: {
    textColor: "#23231F",
  },
  consentItems: {
    backgroundColor: "#ffffff",
    textColor: "#101418",
  },
  displayProcessState: true,
  displayConsentDeeplinkButton: true,
};
